import { createSelector } from 'reselect';
import { getEntry, getNotSetValue } from 'conversations-async-data/indexed-async-data/operators/getters';
import { getIndexedAsyncAssociations } from './getIndexedAsyncAssociations';
const getThreadIdFromProps = (__state, {
  threadId
}) => threadId;
export const getAsyncAssociations = createSelector([getThreadIdFromProps, getIndexedAsyncAssociations], (threadId, indexedAsyncAssociations) => threadId ? getEntry(threadId, indexedAsyncAssociations) : getNotSetValue(indexedAsyncAssociations));